import { ToEntity } from 'core/common/mappers';
import { AskNebulaAccount } from '../entities';
import { AskNebulaAccountDto } from '../services/dto';

export class AskNebulaAccountDtoMapper implements ToEntity<AskNebulaAccount, AskNebulaAccountDto> {
  toEntity(dto: AskNebulaAccountDto): AskNebulaAccount {
    return {
      accountId: dto.account_id,
      userId: dto.user_id,
      email: dto.email,
      confirmed: dto.confirmed,
      isExternal: dto.is_external,
    };
  }
}
